import { Box, CssBaseline, ThemeProvider, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import RoutesTwo from "./routes/Routes";
import { useLocation } from "react-router";
import { fetchData } from "./views/utilities/api";
import { SnackBarProvider } from "./context/SnackBarContext";
import { baselightTheme } from "./theme/DefaultColors";
import "./App.css";
import { Provider } from "react-redux";
import store from "./redux/store";

function App() {
  const theme = baselightTheme;
  const location = useLocation();
  
  // State to manage loading status
  const [loading, setLoading] = useState(true);

  // Get the current URL
  const params = location.search;

  let ur_d = params?.slice(8);
  if (ur_d) {
    localStorage.setItem("lgpath", ur_d);
  }

  useEffect(() => {
    const checkLaundry = async () => {
      const data = await fetchData("/api/checkLaundry");
      if (data?.data?.isLaundry === "YES") {
        localStorage.setItem("isLaundry", true);
      } else {
        localStorage.setItem("isLaundry", false);
      }
      // Set loading to false after the API call completes
      setLoading(false);
    };
    
    checkLaundry();
  }, []);

  return (
    <Box sx={{ background: "#edeff6" }}>
      <SnackBarProvider>
        <Provider store={store}>

        <ThemeProvider theme={theme}>
          <CssBaseline />
          {loading ? (
            // Render a loading indicator while waiting for the API response
            <CircularProgress sx={{ display: 'block', margin: 'auto', marginTop: '20%' }} />
          ) : (
            // Render the routes only after loading is complete
            <RoutesTwo />
          )}
        </ThemeProvider>
          </Provider>
      </SnackBarProvider>
    </Box>
  );
}

export default App;
